// Module
var code = "<script id=\"wcc-components-task-topics-slider-page-control\" type=\"text/template\">\r\n    <div class=\"task__topics-slider__page-control__body qzy-primary-color\" data-bind=\"visible: hasToDo\">\r\n        <span class=\"text-xs\" data-bind=\"text: labels.ToDo\"></span>\r\n    </div>\r\n</script>";
// Exports
module.exports = code;